import React from "react";
import { isBrowser } from "../../includes/analytics";
import { ButterBar } from "./butterbar";

export const BrowserButterBar = ()=>{
  const isIE = isBrowser && (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1);
  if (isIE)
    return <ButterBar message="The browser or version you are using is unsupported. If you experience issues, please try another browser or update to the latest version. "/>;
  return <></>;
}